export default "__VITE_ASSET__d545b0df__"